import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isFromBank } from './agent/isFromBank';
import { isFromSeller } from './agent/isFromSeller';
import { isFromBuilder } from './agent/isFromBuilder';
import { isFromLeadFactory } from './agent/isFromLeadFactory';

export const agentBuildersLabel: TComputedPropMapper<string | undefined> = (...args) => {
  const [fromSeller, fromBuilder, fromLeadFactory, fromBank] = [
    isFromSeller,
    isFromBuilder,
    isFromLeadFactory,
    isFromBank,
  ].map(fn => fn(...args));

  if (fromBank) {
    return 'БАНК';
  }

  if (fromBuilder && !fromLeadFactory) {
    return 'Застройщик';
  }

  if (!fromBuilder && fromSeller && !fromLeadFactory) {
    return 'Представитель застройщика';
  }

  if (fromLeadFactory) {
    return 'Консультант';
  }

  return undefined;
};
